import React from 'react'
import PaySlip from './PaySlip';

const PaySlipScreen = () => {
  return (
    <div className="w-full h-screen flex flex-col items-center justify-center">
      <div className="w-3/4 h-3/4 my-10 overflow-auto scrollbar-thin">
        <PaySlip />
      </div>
    </div>
  );
}

export default PaySlipScreen
